import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks/useUserContext'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const UsageAnalyticsApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.USAGE_ANALYTICS}
        scope='usage_analytics'
        envKey={apps[AppId.USAGE_ANALYTICS].runtimeEnvKey}
        entryPath='./UsageAnalyticsApp'
        url={process.env.REACT_APP_USAGE_ANALYTICS_APP_DEV_PATH}
        appName={apps[AppId.USAGE_ANALYTICS].name}
        appProps={{
          user,
          initialPath: apps[AppId.USAGE_ANALYTICS].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  () => true
)

export { UsageAnalyticsApp }
